// Monitoramento Hidrológico (2026-08-21): Estações + Portal do Cliente.
// Eram dois itens vizinhos na sidebar tratando do mesmo assunto — o portal
// existe POR CAUSA das estações: é onde o cliente vê a série da estação dele.
//
// Mantém o path novo `/operacional/monitoramento`; os dois paths antigos viram
// RedirectHub com a aba certa, preservando a query string (deep-link de
// estação e link de notificação do portal continuam valendo).
import HubAbas, { HubTab } from '../components/HubAbas';
import EstacoesMapa from './EstacoesMapa';
import PortalClientesAdmin from './PortalClientesAdmin';

const TABS: HubTab[] = [
  { key: 'estacoes', label: '📡 Estações',          perm: 'monitoramento.estacoes.ver',     render: () => <EstacoesMapa /> },
  { key: 'portal',   label: '👥 Portal do Cliente', perm: 'monitoramento.portal.gerenciar', render: () => <PortalClientesAdmin /> },
];

export default function OperacionalMonitoramentoHub() {
  return <HubAbas tabs={TABS} />;
}
